import moduleDescriptions from 'root/src/shared/descriptions/modules'

import {
	bannerHeaderModuleDescriptionLenses,
} from 'root/src/client/logic/header/lenses'

const { viewGiveawayLink } = bannerHeaderModuleDescriptionLenses

export default (state, { moduleId }) => viewGiveawayLink(
	moduleId, moduleDescriptions,
)
